import styled from 'styled-components'

import _Form from '~/components/form'

export const Form = styled(_Form)``
